export type ShoppingListSource = {
  mealId: string;
  mealName: string;
  quantity: string;
};

export type ShoppingListEntry = {
  id: string;
  ingredient: { id: string; name: string } | null;
  customName: string | null;
  displayName: string;
  checked: boolean;
  sources: ShoppingListSource[];
};

export const mapShoppingListEntryFromApi = (entry: any): ShoppingListEntry => ({
  id: entry.id,
  ingredient: entry.ingredient ? { id: entry.ingredient.id, name: entry.ingredient.name } : null,
  customName: entry.customName ?? null,
  displayName: entry.displayName ?? entry.ingredient?.name ?? entry.customName ?? '',
  checked: entry.checked,
  sources: (entry.sources ?? []).map((source: any) => ({
    mealId: source.mealId,
    mealName: source.mealName,
    quantity: source.quantity,
  })),
});
